// extracted by mini-css-extract-plugin
export default {"reasons":"ModalReasonEdit_reasons__kJh5k","reason__label":"ModalReasonEdit_reason__label__B50iZ"};